import TopNav from './components/TopNav';
import Hero from './components/Hero';
import HeatStrip from './components/HeatStrip';
import CoverLibrary from './components/CoverLibrary';
import PaletteGrid from './components/PaletteGrid';
import LayoutGrid from './components/LayoutGrid';
import TuneSection from './components/TuneSection';
import StyleArchive from './components/StyleArchive';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-950">
      <TopNav />
      <main>
        <Hero />
        <HeatStrip />
        <CoverLibrary />
        <PaletteGrid />
        <LayoutGrid />
        <TuneSection />
        <StyleArchive />
      </main>
      <Footer />
    </div>
  );
}